<template>
  <div style="background: linear-gradient(to bottom, #eee, #eee)">
    <div class="h5bg" v-if="xjhInfo" style="border: 0; height: 70px; background: none">
      <div
        style="
          position: absolute;
          width: 57px;
          height: 54px;
          bottom: -5px;
          left: 50px;
          z-index: 1;
        "
      >
        <img :src="'./img/jiazi.png'" />
      </div>

      <div
        style="
          position: absolute;
          width: 57px;
          height: 54px;
          bottom: -5px;
          right: 50px;
          z-index: 1;
        "
      >
        <img :src="'./img/jiazi.png'" />
      </div>

      <div
        v-if="xjhInfo && xjhInfo.qrcode"
        style="
          position: absolute;
          width: 200px;
          height: 230px;
          top: 230px;
          right: 50px;
          z-index: 1;
        "
      >
        <img :src="xjhInfo.qrcode" style="width: 100%; heiht: 100%" />
        <div
          style="
            width: 90px;
            height: 90px;
            position: absolute;
            top: 55px;
            left: 55px;
            background: #fff;
            border-radius: 50%;
          "
        >
          <img :src="logo" style="width: 100%; heiht: 100%;border-radius:50%" />
        </div>
        <div style="text-align:center">扫码报名</div>
      </div>
    </div>
    <div class="h5bg" v-if="xjhInfo">
      <div class="title">{{ xjhInfo.title_main }}</div>
      <div style="text-align:center;border-bottom:1px solid #ccc;padding-bottom:20px;padding-top:10px">{{ xjhInfo.title_desc }}</div>
      <div class="desc">
        
        <div>
          <div>宣讲会开始时间：{{ xjhInfo.stime }}</div>
          <div>报名截止时间：{{ xjhInfo.etime }}</div>
          <div>宣讲会地点：{{ xjhInfo.xjh_address }}</div>
        </div>
      

        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="宣讲会详情" name="first"></el-tab-pane>
          <el-tab-pane label="企业简介" name="second"></el-tab-pane>
          <el-tab-pane label="职位列表" name="third"></el-tab-pane>
        </el-tabs>
        <div v-if="activeName == 'first' && xjhInfo">
          <div v-html="xjhInfo.html_content"></div>

          <el-image
          v-for="(file, i) in xjhInfo.files"
          :key="i"
          class="fileitem"
          :src="file.src"
          fit="cover"
          :preview-src-list="[file.src]"
        ></el-image>


        </div>
        <div v-if="activeName == 'second' && xjhInfo">
          <div v-html="xjhInfo.enter_desc"></div>
        </div>
        <div v-if="activeName == 'third'">
          <table class="dttable" v-for="(job,idx) in xjhInfo.job_desc" :key="idx" style="margin-bottom:20px">
            <tr>
              <td class="tdheadersml">职位{{idx+1}}</td>
              <td>{{job.job_name}}</td>
              <td class="tdheadersml">职位类型</td>
              <td>{{job.job_type}}</td>
            </tr>
           
            <tr v-if="job.job_num">
              <td class="tdheadersml">招聘人数</td>
              <td>{{job.job_num}}</td>
              <td class="tdheadersml">薪资待遇</td>
              <td>{{job.salary}}</td>
            </tr>
           
            <tr v-if="job.city_name">
              <td class="tdheadersml">工作城市</td>
              <td>{{job.city_name}}</td>
              <td class="tdheadersml">工作地点</td>
              <td>{{job.job_address}}</td>
            </tr>
            
            <tr v-if="job.job_require">
              <td class="tdheadersml">职位要求</td>
              <td colspan='3' v-html="job.job_require"></td>
            </tr>
            <tr v-if="job.job_desc">
              <td class="tdheadersml">职位简介</td>
              <td  colspan='3' v-html="job.job_desc"></td>
            </tr>

          </table>
        </div>
      </div>
    </div>

    <div style="height: 100px"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: 0,
      entInfo: null,
      xjhInfo: null,
      activeName: "first",
      schoolname: "",
      logo: "",
    };
  },
  mounted() {
    document.title = "企业宣讲会";
    this.id = this.$route.params.id;
    this.getData();
   
  },
  methods: {

   

    getConfig() {
      this.$http.post("/api/sch_config_one", { ktype: "schoolname",pmid:window.pmid }).then((res) => {
        this.schoolname = res.data.kvalue;
      });
      this.$http.post("/api/sch_config_one", { ktype: "applogo" ,pmid:window.pmid}).then((res) => {
        this.logo = res.data.kvalue;
      });

      this.$http.post("/api/sch_config_one", { ktype: "favico" ,pmid:window.pmid}).then((res) => {
        let favico = res.data.kvalue;
        if (favico) {
          var link = document.createElement('link');
          link.type = 'image/x-icon';
          link.rel = 'shortcut icon';
          link.href = favico;
          document.getElementsByTagName('head')[0].appendChild(link);
        }
      });
    },
    getData() {
      this.$http.post("/api/h5_xjh_info", { id: this.id }).then((res2) => {
          this.xjhInfo = res2.data;
          document.title = this.xjhInfo.title_main
          window.pmid = res2.data.pmid
          res2.data.stime = res2.data.stime.substr(0, 16);
        res2.data.etime = res2.data.etime.substr(0, 16);
        try {
          res2.data.files = JSON.parse(res2.data.files);
          res2.data.job_desc = JSON.parse(res2.data.job_desc);
          for(let job of res2.data.job_desc){
            job.job_require = job.job_require.replace(/\n/g,"<br />")
            job.job_desc = job.job_desc.replace(/\n/g,"<br />")
          }
        } catch (error) {}

          this.getConfig();
          if (!this.xjhInfo.qrcode) {
            this.$http
              .post("/api/h5_xjh_qrcode", { id: this.xjhInfo.id,pmid:window.pmid })
              .then((qrcode) => {
                this.xjhInfo.qrcode = qrcode.data.url;
              });
          }
        });
    },
  },
};
</script>

<style scoped>
.h5bg {
  max-width: 1000px;
  border: 10px solid #fff;
  margin: 0 auto;
  background: #fff;
  position: relative;
  padding: 20px;
  color: #373d5e;
}
.title {
  font-size: 34px;
  text-align: center;
  color: blue;
  padding-top: 50px;
  text-stroke: 2px white;
  -webkit-text-stroke: 1px white;
}
.desc {
  line-height: 50px;
}

.fileitem {
  width: 150px;
  height: 150px;
  border: 1px dotted #ccc;
  display: inline-block;
  vertical-align: top;
  margin: 0 10px 10px 0;
  cursor: pointer;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 50px;
  color: #ccc;
  background-position: center;
  background-repeat: norepeat;
  background-size: cover;
}
</style>
